angular.module('app.api').factory('NotesApi', [
  'api',
  function NotesApi(api) {
    const notesApi = {
      getAllNotes: payload => {
        return api.get(`notes`, {params: payload})
      },
      createNote: async payload => {
        return api.post('notes', payload)
      },
      updateNote: async (id, payload) => {
        return api.put(`notes/${id}`, payload)
      },
      deleteNote: (id, parameter) => {
        return api.delete(`notes/${id}`, {params: parameter})
      },
      getNoteHistory: payload => {
        return api.get(`actions`, {params: payload})
      },
    }
    return notesApi
  },
])



// WEBPACK FOOTER //
// ./scripts/notes/notes.api.js